import FileSaver from "file-saver";

//TODO need to find a way for the url string replacers.

const fetchAscii = obj => {
    if (!obj) return 0;
    let convertedObj = 0;

    for (let i = 0; i < obj.length; i++) {
        let asciiChar = obj.charCodeAt(i);

        convertedObj += asciiChar;
    }

    return convertedObj;
};

const transformParmstoAsciiCheckSum = paramsObj => {
    let asciiParamsSum = 0;

    if (paramsObj) {
        Object.keys(paramsObj).forEach(function(key) {
            asciiParamsSum += fetchAscii(key) + fetchAscii(paramsObj[key]);
        });
    }

    return asciiParamsSum;
};

export const downloadAPIResponseJSON = response => {
    String.prototype.replaceAll = function(search, replacement) {
        let target = this;
        return target.replace(new RegExp(search, "g"), replacement);
    };

    let stringifiedResponse = JSON.stringify(response.data);
    let uglyUrl = response.config.url.split("3000")[1];
    uglyUrl = uglyUrl.replaceAll(" ", ")");
    let url = uglyUrl;

    let method = response.config.method;

    let paramsObj = response.config.params;
    let asciiParamsSum = paramsObj
        ? transformParmstoAsciiCheckSum(paramsObj)
        : 0;

    let blob = new Blob([stringifiedResponse], { type: "application/json" });

    let fileName = asciiParamsSum
        ? `${method}${url}${asciiParamsSum}`
        : `${method}${url}`;

    FileSaver.saveAs(blob, `${fileName}.json`);
};

export const changeRequestConfigToMockURL = (config, mockServerUrl) => {
    String.prototype.replaceAll = function(search, replacement) {
        let target = this;
        return target.replace(new RegExp(search, "g"), replacement);
    };

    let uglyUrl = config.url.split("3000")[1];
    uglyUrl = uglyUrl.replaceAll("/", "-");
    uglyUrl = uglyUrl.replaceAll(" ", ")");
    let url = uglyUrl.replaceAll("\\?", "-");

    let paramsObj = config.params;
    let asciiParamsSum = paramsObj
        ? transformParmstoAsciiCheckSum(paramsObj)
        : 0;

    let transformURl = asciiParamsSum
        ? `${config.method}${url}${asciiParamsSum}`
        : `${config.method}${url}`;
    config.url = `${mockServerUrl}/${transformURl}.json`;
    config.method = "get";
    config.params = null;
};





// WEBPACK FOOTER //
// ./src/utils/mockAPIWorker.js